<ion-app>
    <!--<app-encabezado></app-encabezado>-->
    <ion-router-outlet></ion-router-outlet>
    <!--<app-pie></app-pie>-->
</ion-app>